import useProfile from "./hooks/useProfile";
import ProfileHeader from "./components/ProfileHeader";
import ProfileDetails from "./components/ProfileDetails";

export default function Profile() {
  const {
    user,
    loading,
    courierName,
    courierType,
  } = useProfile(); 

  if (loading) {
    return (
      <div className="border rounded p-4 md:px-7 md:py-5">
        <ProfileHeader />
        <div className="animate-pulse space-y-4 w-full md:w-1/2">
          <div className="h-10 bg-gray-200 rounded"></div>
          <div className="h-10 bg-gray-200 rounded"></div>
          <div className="h-10 bg-gray-200 rounded"></div>
          <div className="h-10 bg-gray-200 rounded"></div>
          <div className="h-10 bg-gray-200 rounded"></div>
          <div className="h-10 bg-gray-200 rounded"></div>
          <div className="h-10 bg-gray-200 rounded"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="border rounded p-4 md:px-7 md:py-5">
      <ProfileHeader />
      <ProfileDetails
        user={user}
        courierName={courierName}
        courierType={courierType}
      />
    </div>
  );
}
